class FabricLeatherSwatch extends HTMLElement {
  static get observedAttributes() {
    return ['color-name', 'color-handle', 'selected', 'variant-label', 'product-handle'];
  }
  static getSelectedSwatch() {
    const selectedSwatch = document.querySelector('fabric-leather-swatch[selected]');
    if (selectedSwatch) {
      return {
        variantLabel: selectedSwatch.getAttribute('variant-label'),
        colorName: selectedSwatch.getAttribute('color-name')
      };
    }
    return null;
  }
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            width: 100%;
            height: 140px;
            overflow: hidden;
            cursor: pointer;
            transition: border-color 0.2s ease;
            transform: translateZ(0);
            will-change: transform;
          }
          :host([selected]) {
            border: 2px solid var(--colorTextBody);
          }
          :host(:not([selected])) {
            border: 2px solid var(--colorBorder);
          }
          .swatch {
            width: 100%;
            height: 100%;
          }
        </style>
        <div class="swatch" part="swatch"></div>
      `;

    this.swatch = this.shadowRoot.querySelector('.swatch');
    this.addEventListener('click', this._handleClick.bind(this));
  }

  async _handleClick(e) {
    e.preventDefault();

    FabricLeatherSwatch.isUpdatingProgrammatically = true;

    const detail = {
      productHandle: this.getAttribute('product-handle'),
      variantLabel: this.getAttribute('variant-label'),
      colorName: this.getAttribute('color-name')
    };

    const event = new CustomEvent('swatch:selected', {
      bubbles: true,
      composed: true,
      detail
    });

    this.dispatchEvent(event);
  }

  connectedCallback() {
    this.updateSwatch();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.updateSwatch();
    }
  }

  updateSwatch() {
    const colorHandle = this.getAttribute('color-handle');
    if (colorHandle) {
      this.classList.add(`swatch-${colorHandle}`);
    }
  }

  static initFabricLeatherPicker(container) {
    const trigger = container.querySelector('.collapsible-trigger2');
    if (!trigger) return;

    // Use a named function for the click handler
    const handleTriggerClick = () => {
      const productContentSwatch = document.getElementById('Product-content-swatch');
      const collapseTriggerbtn = document.getElementById('collapsible-trigger-btn');

      if (productContentSwatch.classList.contains('is-open')) {
        productContentSwatch.style.height = '0';
        productContentSwatch.classList.remove('is-open');
        collapseTriggerbtn.classList.remove('is-open');
      } else {
        productContentSwatch.style.height = '583px';
        productContentSwatch.classList.add('is-open');
        collapseTriggerbtn.classList.add('is-open');
      }
    };

    // Remove existing listener before adding new one
    trigger.removeEventListener('click', handleTriggerClick);
    trigger.addEventListener('click', handleTriggerClick);

    // Create a bound version of filterProducts
    const filterProducts = (event) => {
      const searchInput = event.target;
      const keyword = searchInput.value.toLowerCase();

      const fabricItems = document.querySelectorAll('#fabric-products .fabric-item');
      const leatherItems = document.querySelectorAll('#leather-products .leather-item');

      const fabricSection = document.getElementById('fabric-products');
      const leatherSection = document.getElementById('leather-products');
      const fabricTitle = document.getElementById('fabric-products-title');
      const leatherTitle = document.getElementById('leather-products-title');
      const noItemFoundMessage = document.getElementById('no-item-found');
      const productContentSwatch = document.getElementById('Product-content-swatch');

      // Store current open state
      const wasOpen = productContentSwatch.classList.contains('is-open');

      // First do all the filtering
      const filterItems = (items) => {
        let hasMatch = false;
        items.forEach(item => {
          const colorName = item.nextElementSibling.textContent.toLowerCase();
          if (colorName.includes(keyword)) {
            item.parentElement.style.display = '';
            hasMatch = true;
          } else {
            item.parentElement.style.display = 'none';
          }
        });
        return hasMatch;
      };

      const fabricHasMatch = filterItems(fabricItems);
      const leatherHasMatch = filterItems(leatherItems);

      fabricSection.style.display = fabricHasMatch ? '' : 'none';
      fabricTitle.style.display = fabricHasMatch ? '' : 'none';
      leatherSection.style.display = leatherHasMatch ? '' : 'none';
      leatherTitle.style.display = leatherHasMatch ? '' : 'none';
      noItemFoundMessage.style.display = (fabricHasMatch || leatherHasMatch) ? 'none' : '';

      FabricLeatherSwatch.adjustSwatchImagesHeight(container);

      // Restore open state and height
      if (wasOpen) {
        productContentSwatch.classList.add('is-open');
        productContentSwatch.style.height = '583px';
      }
    };

    const searchInput = container.querySelector('#search-input');
    if (searchInput) {
      searchInput.removeEventListener('keyup', filterProducts);
      searchInput.addEventListener('keyup', filterProducts);
    }

    FabricLeatherSwatch.adjustSwatchImagesHeight(container);

    // Handle window resize
    if (window.fabricPickerResizeHandler) {
      window.removeEventListener('resize', window.fabricPickerResizeHandler);
    }
    window.fabricPickerResizeHandler = () => FabricLeatherSwatch.adjustSwatchImagesHeight(container);
    window.addEventListener('resize', window.fabricPickerResizeHandler);
  }

  static adjustSwatchImagesHeight(container) {
    const swatchWrappers = container.querySelectorAll('.swatch-wrapper');
    swatchWrappers.forEach(wrapper => {
      const width = wrapper.offsetWidth;
      const swatchImage = wrapper.querySelector('.swatch-image');
      if (swatchImage) {
        swatchImage.style.height = `${width}px`;
      }
    });
  }

  static isUpdatingProgrammatically = false;

  static async setSelectedSwatch(variantLabel, colorName) {
    try {
      // Skip dropdown opening logic
      const newSwatch = document.querySelector(
        `fabric-leather-swatch[variant-label="${variantLabel}"][color-name="${colorName}"]`
      );

      if (newSwatch) {
        // Set flag to true before triggering click
        FabricLeatherSwatch.isUpdatingProgrammatically = false;

        // Create and dispatch the custom event directly instead of clicking
        const detail = {
          productHandle: newSwatch.getAttribute('product-handle'),
          variantLabel: variantLabel,
          colorName: colorName
        };

        const event = new CustomEvent('swatch:selected', {
          bubbles: true,
          composed: true,
          detail
        });

        newSwatch.dispatchEvent(event);
      }
      return newSwatch;
    } catch (error) {
      console.error('Error in setSelectedSwatch:', error);
      return null;
    } finally {
      // Reset flag after operation is complete
    }
  }
}

customElements.define('fabric-leather-swatch', FabricLeatherSwatch);